import { ForecastWidgetConfig, WidgetRenderContext, WidgetRenderer } from '../types';

export class OpticsDewRiskWidget implements WidgetRenderer {
  public renderHtml(widget: ForecastWidgetConfig, ctx: WidgetRenderContext): string {
    const title = widget.title || 'Optics Dew Risk Index';
    const dew = ctx.data.opticsDewRisk;
    const badgeText = dew?.badge || '🟢 LOW DEW RISK';
    const isHeavy = dew?.level === 'heavy';
    const isMod = dew?.level === 'moderate';

    const badgeStyle = isHeavy
      ? 'background: rgba(239, 68, 68, 0.2); color: #f87171; border: 1px solid rgba(239, 68, 68, 0.3);'
      : isMod
      ? 'background: rgba(234, 179, 8, 0.2); color: #facc15; border: 1px solid rgba(234, 179, 8, 0.3);'
      : 'background: rgba(34, 197, 94, 0.2); color: #4ade80; border: 1px solid rgba(34, 197, 94, 0.3);';

    return `
      <div class="metric-card" style="background: rgba(255,255,255,0.03); border: 1px solid var(--border-light); border-radius: 8px; padding: 12px;">
        <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid rgba(255,255,255,0.05); padding-bottom: 6px; margin-bottom: 8px;">
          <h3 style="margin: 0; color: #f8fafc; font-size: 0.95rem;">💧 ${title}</h3>
          <div style="font-size: 0.82rem; font-weight: bold; padding: 3px 10px; border-radius: 6px; ${badgeStyle}">
            ${badgeText}
          </div>
        </div>
        <div style="font-size: 0.75rem; color: #94a3b8;">
          Monitors radiational cooling on camera lenses & telescope glass to alert for heavy condensation.
        </div>
      </div>
    `;
  }

  public init(_widget: ForecastWidgetConfig, _ctx: WidgetRenderContext): void {
    // Pure DOM rendering
  }
}
